import React from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { formatSurveySectionRoute } from '../../Survey/routes';
import {
  getResetAnswersStatus,
  getSurveyResponses,
} from '../../Survey/surveySlice';

const ResetAnswersRedirect = () => {
  const { projectId } = useParams();

  const surveyResponses = useSelector(getSurveyResponses);
  const { success: resetAnswerSuccess } = useSelector(getResetAnswersStatus);

  const sectionPath = surveyResponses && surveyResponses.sections[0].path;

  return (
    resetAnswerSuccess &&
    surveyResponses && (
      <Redirect to={formatSurveySectionRoute(projectId, sectionPath)} />
    )
  );
};

export default ResetAnswersRedirect;
